__turbopack_context__.v({
  "calendarCard": "OrganizerCalendar-module-scss-module__GPf_AG__calendarCard",
  "calendarHeader": "OrganizerCalendar-module-scss-module__GPf_AG__calendarHeader",
  "calendarSkeletonPulse": "OrganizerCalendar-module-scss-module__GPf_AG__calendarSkeletonPulse",
  "dayButton": "OrganizerCalendar-module-scss-module__GPf_AG__dayButton",
  "dayCircle": "OrganizerCalendar-module-scss-module__GPf_AG__dayCircle",
  "daySkeleton": "OrganizerCalendar-module-scss-module__GPf_AG__daySkeleton",
  "daysGrid": "OrganizerCalendar-module-scss-module__GPf_AG__daysGrid",
  "desktopCalendar": "OrganizerCalendar-module-scss-module__GPf_AG__desktopCalendar",
  "eventDot": "OrganizerCalendar-module-scss-module__GPf_AG__eventDot",
  "iconButton": "OrganizerCalendar-module-scss-module__GPf_AG__iconButton",
  "mobileCloseButton": "OrganizerCalendar-module-scss-module__GPf_AG__mobileCloseButton",
  "mobileSheet": "OrganizerCalendar-module-scss-module__GPf_AG__mobileSheet",
  "mobileSheetBody": "OrganizerCalendar-module-scss-module__GPf_AG__mobileSheetBody",
  "mobileSheetHeader": "OrganizerCalendar-module-scss-module__GPf_AG__mobileSheetHeader",
  "mobileSheetTitle": "OrganizerCalendar-module-scss-module__GPf_AG__mobileSheetTitle",
  "mobileToggle": "OrganizerCalendar-module-scss-module__GPf_AG__mobileToggle",
  "monthLabel": "OrganizerCalendar-module-scss-module__GPf_AG__monthLabel",
  "responsiveToggle": "OrganizerCalendar-module-scss-module__GPf_AG__responsiveToggle",
  "tabletCalendar": "OrganizerCalendar-module-scss-module__GPf_AG__tabletCalendar",
  "tabletPopover": "OrganizerCalendar-module-scss-module__GPf_AG__tabletPopover",
  "toggleChip": "OrganizerCalendar-module-scss-module__GPf_AG__toggleChip",
  "toggleChipDateActive": "OrganizerCalendar-module-scss-module__GPf_AG__toggleChipDateActive",
  "toggleChipWrapper": "OrganizerCalendar-module-scss-module__GPf_AG__toggleChipWrapper",
  "toggleChipWrapperDateActive": "OrganizerCalendar-module-scss-module__GPf_AG__toggleChipWrapperDateActive",
  "toggleIcon": "OrganizerCalendar-module-scss-module__GPf_AG__toggleIcon",
  "toggleIconOpen": "OrganizerCalendar-module-scss-module__GPf_AG__toggleIconOpen",
  "weekdayCell": "OrganizerCalendar-module-scss-module__GPf_AG__weekdayCell",
  "weekdayRow": "OrganizerCalendar-module-scss-module__GPf_AG__weekdayRow",
});
